export default "__VITE_ASSET__DslGm0j1__"